import { useTranslation } from "react-i18next";

import Button from "components/Button";
import ImageCreator from "components/ImageCreator";
import Spinner from "components/Spinner";

import DeleteItemDialog from "../DeleteItemDialog";

import { useLogo } from "./useLogo";

interface LogoProps {
  templateLogoPath: string | null;
}

export default function Logo({ templateLogoPath }: LogoProps) {
  const { data, isFetching, inputRef, handleChange, deleteLogoMutation } = useLogo({ templateLogoPath });
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-3.5">
      <div>{t("profile.findings.logo")}</div>
      <input
        ref={inputRef}
        type="file"
        accept="image/png,image/jpeg,image/jpg,image/gif"
        className="hidden"
        onChange={handleChange}
      />
      {!templateLogoPath && (
        <Button type="button" className="w-full" onClick={() => inputRef.current?.click()} variant="dotted">
          {t("button.upload")}
        </Button>
      )}
      {templateLogoPath && (
        <>
          <ImageCreator data={data} alt="Logo preview" className="max-h-40 object-contain bg-general-gray-300" />
          <div className="flex items-center gap-2">
            <DeleteItemDialog onConfirm={() => deleteLogoMutation.mutate()} logo={data} />
          </div>
        </>
      )}
      {isFetching && (
        <div className="flex items-center justify-center h-40 bg-general-gray-300">
          <Spinner />
        </div>
      )}
    </div>
  );
}
